<template>
  <el-container>
    <el-aside width="260px">
      <search-form></search-form>
      <el-divider></el-divider>
      <!-- <model-pagination></model-pagination> -->
      <stock-tree></stock-tree>
    </el-aside>
    <el-container>
      <el-header>
        <nav-header></nav-header>
      </el-header>
      <el-main>
        <daily-kline></daily-kline>
      </el-main>
      <el-header>
        <h2>京ICP备2021016334号</h2>
      </el-header>
    </el-container>
  </el-container>
</template>
<script>
import SearchForm from "@/components/SearchForm.vue";
import DailyKline from "@/components/DailyKline.vue";
import ModelPagination from "@/components/ModelPagination.vue";
import NavHeader from "@/components/NavHeader.vue";
import StockTree from "@/components/StockTree.vue";

export default {
  components: { SearchForm, DailyKline, StockTree, NavHeader }
};
</script>



// WEBPACK FOOTER //
// src/components/MainLayout.vue